import { OnboardingStatus, VerificationStatus } from '../../utils/hooks/useWorldCheckVerification.hook';

export const verificationStatusColors: Record<string, string> = {
  [VerificationStatus.REQUIRED]: 'rgb(145, 148, 150)',
  [VerificationStatus.PENDING]: 'rgb(24, 144, 255)',
  [VerificationStatus.LOW_RISK]: 'rgb(82, 196, 26)',
  [VerificationStatus.HIGH_RISK_FIR]: 'rgb(207, 19, 34)',
  [VerificationStatus.HIGH_RISK_EDD]: 'rgb(207, 19, 34)',
  [VerificationStatus.MEDIUM_RISK]: 'rgb(250, 219, 20)',
};

export const verificationStatus = {
  [VerificationStatus.REQUIRED]: 'Required',
  [VerificationStatus.PENDING]: 'Pending',
  [VerificationStatus.LOW_RISK]: 'Low Risk',
  [VerificationStatus.MEDIUM_RISK]: 'Medium Risk',
  [VerificationStatus.HIGH_RISK_FIR]: 'High Risk (FIR)',
  [VerificationStatus.HIGH_RISK_EDD]: 'High Risk (EDD)',
};

export const onboardingStatusColors: Record<string, string> = {
  // [OnboardingStatus.PENDING]: "#F28A28",
  [OnboardingStatus.INVITED]: "#F28A28",
  [OnboardingStatus.SUBMITTED]: "#F28A28",
  [OnboardingStatus.REJECTED]: "#EC3333",
  [OnboardingStatus.APPROVED]: "#18B853",
  [OnboardingStatus.BLOCKED]: "#E53935",
  [OnboardingStatus.RESTRICTED]: "#EC3333",
};

export const onboardingStatus = {
  // [OnboardingStatus.PENDING]: 'Pending',
  [OnboardingStatus.INVITED]: 'Invited',
  [OnboardingStatus.SUBMITTED]: 'Submited',
  [OnboardingStatus.REJECTED]: 'Rejected',
  [OnboardingStatus.APPROVED]: 'Approved',
  [OnboardingStatus.BLOCKED]: 'Blocked',
  [OnboardingStatus.RESTRICTED]: 'Restricted',
};
